/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Kind_ProfileInputs */

const en_us2_offline_kind_profile = /** @type {(inputs: Offline_Kind_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile change`)
};

const pt_br2_offline_kind_profile = /** @type {(inputs: Offline_Kind_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alteração no perfil`)
};

const es_419_offline_kind_profile = /** @type {(inputs: Offline_Kind_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio en el perfil`)
};

const pt_pt2_offline_kind_profile = /** @type {(inputs: Offline_Kind_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alteração no perfil`)
};

const fr_fr2_offline_kind_profile = /** @type {(inputs: Offline_Kind_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modification du profil`)
};

const de_de2_offline_kind_profile = /** @type {(inputs: Offline_Kind_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profiländerung`)
};

const it_it2_offline_kind_profile = /** @type {(inputs: Offline_Kind_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica al profilo`)
};

/**
* | output |
* | --- |
* | "Profile change" |
*
* @param {Offline_Kind_ProfileInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_kind_profile = /** @type {((inputs?: Offline_Kind_ProfileInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Kind_ProfileInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_kind_profile(inputs)
	if (locale === "es-419") return es_419_offline_kind_profile(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_kind_profile(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_kind_profile(inputs)
	if (locale === "de-DE") return de_de2_offline_kind_profile(inputs)
	if (locale === "it-IT") return it_it2_offline_kind_profile(inputs)
	return en_us2_offline_kind_profile(inputs)
});
export { offline_kind_profile as "offline.kind_profile" }